'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTemplate = renderTemplate;

var _handlebars = require('handlebars');

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utility functions for use with our templating engine.
 */

/**
 * Renders a Handlebars Template.
 *
 * @param  {Object} data          The template input.
 * @param  {String} templateId    Handlebars template script id.
 * @param  {String} placeholderSelector Selector to the output element.
 */
function renderTemplate(data, templateId, placeholderSelector) {

  var source = document.querySelector('#' + templateId).innerHTML,
      template = _handlebars2.default.compile(source),
      rendered = template(data);

  document.querySelector('' + placeholderSelector).innerHTML = rendered;
}